/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Select, MenuItem, InputLabel } from "@mui/material";

const LinkButtonSelectOption = (props) => {

    const label = props?.label;
    const onChange = props?.onChange;
    const options = props?.options;
    const value = props?.value;

    const labelId = `link-button-select-${label}-label`;
    const selectId = `link-button-select-${label}`;

    return (
        <div className='link-button-select-option'>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                className='link-button-select'
                labelId={labelId}
                id={selectId}
                value={value || ""}
                onChange={onChange}
                variant='standard'
            >
                {options && options.map((option) => {
                    const displayTitle = option?.displayTitle;
                    const value = option?.value;
                    return (
                        <MenuItem key={`link-button-option-${value}`} value={value}>
                            {displayTitle}
                        </MenuItem>
                    );
                })}
            </Select>
        </div>
    );
};
export default LinkButtonSelectOption;
